



























































































































import Vue from 'vue'
import { KeyActionEnum, SnackbarStateEnum } from '@/types/enums'
import ProgressCircular from '@/components/ProgressCircular.vue'
import {
  DxColumn,
  DxColumnChooser,
  DxDataGrid,
  DxFilterRow, DxGrouping,
  DxGroupPanel,
  DxScrolling, DxSelection,
  DxSorting, DxStateStoring
} from 'devextreme-vue/data-grid'
import { hexToRgba } from '@/services/hex-to-rgba'
import DeleteDialog from '@/components/DeleteDialog.vue'
import { KeyAction } from '@/model/KeyAction'
import { keyActionService } from '@/services/key-action-service'
import { ConfigurationDescriptionLanguage, UiLanguageItem, UiLanguageList } from '@/types'
import DescriptionLanguagesDialog from '@/components/settings/configuration/DescriptionLanguagesDialog.vue'
import { GET_SELECTED_UI_LANGUAGE } from '@/store/getter-types'

class Create extends KeyAction {}
class Edit extends KeyAction {}
class Delete extends KeyAction {}
class Save extends KeyAction {}
class Cancel extends KeyAction {}

interface ComponentData {
  rules: Function[]
  loading: boolean
  saveLoading: boolean
  showSnackbar: boolean
  messageSnackbar: string
  snackbarState: number
  showDeleteDialog: boolean
  showDescriptionLanguagesDialog: boolean

  isEdit: boolean

  tableHeight: string
  selectedConfigurationIndex: number | null
  selectedConfiguration: any | null
  configurationList: any[]

  gruppe: number | null
  code: string | null
  bezeichnung: string | null
  languagesDialogDescriptionData: ConfigurationDescriptionLanguage[]
  artList: any[]
  art: number | null
  pflichtfeld: boolean
  produkt: boolean
  produktadresse: boolean
  adresse: boolean
  sachbearbeiter: boolean
  projekt: boolean
  projektDetail: boolean
  stammSLKomponente: boolean
  projektSLKomponente: boolean
  kommission: boolean
  seriennummer: boolean
  profitCenter: boolean
  produktOPSchritte: boolean
  projektDetailOPSchritte: boolean
  mitarbeiter: boolean
  projektSerien: boolean

  keyActions: KeyAction[]
}

export default Vue.extend({
  name: 'ConfigurationForm172',

  components: {
    ProgressCircular,
    DxDataGrid,
    DxColumn,
    DxColumnChooser,
    DxSorting,
    DxFilterRow,
    DxGroupPanel,
    DxGrouping,
    DxScrolling,
    DxSelection,
    DxStateStoring,
    DeleteDialog,
    DescriptionLanguagesDialog
  },

  props: {
    formData: Array as () => any[],
    gruppeList: Array as () => any[],
  },

  data (): ComponentData {
    return {
      rules: [(value: any): boolean | string => !!value || this.$t('masterData.shifts.required').toString()],
      loading: false,
      saveLoading: false,
      showSnackbar: false,
      messageSnackbar: '',
      snackbarState: 0,
      showDeleteDialog: false,
      showDescriptionLanguagesDialog: false,

      isEdit: false,

      tableHeight: '',
      selectedConfigurationIndex: null,
      selectedConfiguration: null,
      configurationList: [],

      gruppe: null,
      code: null,
      bezeichnung: null,
      languagesDialogDescriptionData: [],
      artList: [],
      art: null,
      pflichtfeld: false,
      produkt: false,
      produktadresse: false,
      adresse: false,
      sachbearbeiter: false,
      projekt: false,
      projektDetail: false,
      stammSLKomponente: false,
      projektSLKomponente: false,
      kommission: false,
      seriennummer: false,
      profitCenter: false,
      produktOPSchritte: false,
      projektDetailOPSchritte: false,
      mitarbeiter: false,
      projektSerien: false,

      keyActions: []
    }
  },

  watch: {
    isEdit (newVal: boolean): void {
      if(newVal) {
        setTimeout(() => {
          const focusedField: any = this.$refs['focusedField']
          if (focusedField) {
            focusedField.focus()
          }
        }, 0)
      } else {
        setTimeout(() => {
          const focusedButton: any = this.$refs['focusedButton']
          if (focusedButton) {
            focusedButton.$el.focus()
          }
        }, 0)
      }
    },

    bezeichnung (newVal: string | null): void {
      let foundText: ConfigurationDescriptionLanguage | undefined = this.languagesDialogDescriptionData.find((item: ConfigurationDescriptionLanguage) => item.languageId === this.selectedLanguageId)
      if(foundText) {
        foundText.text =  newVal ? newVal : ''
      }
    },
  },

  computed: {
    snackbarColor (): boolean {
      return this.snackbarState === SnackbarStateEnum.Success
    },

    toolbarColor (): string {
      return hexToRgba(this.$vuetify.theme.themes.light.primary)
    },

    uiLanguageList (): UiLanguageList {
      return this.$store.state.uiLanguageList
    },

    selectedLanguageId (): number {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].syzId
    },

    isDisabledInsertButton (): boolean {
      return this.saveLoading || this.isEdit || !this.gruppe
    },

    isDisabledUpdateButton (): boolean {
      return !this.selectedConfiguration || this.isEdit
    },

    isDisabledDeleteButton (): boolean {
      return !this.selectedConfiguration || this.isEdit
    }
  },

  methods: {
    onKeydown (event: any): void {
      const action: any = keyActionService(event, this.keyActions)
      action && action.handle()
    },

    resolver (action: Create | Edit | Delete | Save | Cancel | null): boolean {
      if(action instanceof Create) {
        return !this.isDisabledInsertButton
      } else if(action instanceof Edit) {
        return !this.isDisabledUpdateButton
      } else if(action instanceof Delete) {
        return !this.isDisabledDeleteButton
      } else if(action instanceof Save) {
        return this.isEdit && !this.saveLoading
      } else if(action instanceof Cancel) {
        return this.isEdit && !this.saveLoading
      } else {
        return false
      }
    },

    onDescriptionLanguagesClick (): void {
      this.showDescriptionLanguagesDialog = true
    },

    onDescriptionLanguagesDialogSave (data: ConfigurationDescriptionLanguage[]): void {
      this.languagesDialogDescriptionData = data
      const foundDescription: ConfigurationDescriptionLanguage | undefined = this.languagesDialogDescriptionData.find((item: ConfigurationDescriptionLanguage) => item.languageId === this.selectedLanguageId)
      this.bezeichnung = foundDescription ? foundDescription.text : null
      this.onDescriptionLanguagesDialogClose()
    },

    onDescriptionLanguagesDialogClose (): void {
      this.showDescriptionLanguagesDialog = false
    },

    onAddConfigurationClick (): void {
      this.isEdit = true
      this.selectedConfigurationIndex = null
      this.selectedConfiguration = null
      //@ts-ignore
      setTimeout(() => {this.$refs.dataGrid.instance.selectRows([])}, 100)

      this.gruppe = null
      this.code = null
      this.bezeichnung = null
      this.art = null
      this.pflichtfeld = false
      this.produkt = false
      this.produktadresse = false
      this.adresse = false
      this.sachbearbeiter = false
      this.projekt = false
      this.projektDetail = false
      this.stammSLKomponente = false
      this.projektSLKomponente = false
      this.kommission = false
      this.seriennummer = false
      this.profitCenter = false
      this.produktOPSchritte = false
      this.projektDetailOPSchritte = false
      this.mitarbeiter = false
      this.projektSerien = false
      const form: any = this.$refs['form']
      form.resetValidation()
    },

    create (action?: KeyAction | null): void {
      if(action) {
        action.event.preventDefault()
      }

      this.onAddConfigurationClick()
    },

    onEditConfigurationsClick (): void {
      this.isEdit = true
    },

    update (action?: KeyAction | null): void {
      if(action) {
        action.event.preventDefault()
      }

      this.onEditConfigurationsClick()
    },

    onDeleteConfigurationClick (): void {
      this.showDeleteDialog = true
    },

    delete (action?: KeyAction | null): void {
      if(action) {
        action.event.preventDefault()
      }

      this.onDeleteConfigurationClick()
    },

    onDeleteDialogClose (): void {
      this.showDeleteDialog = false
    },

    onDeleteDialogSave (): void {
      this.deleteConfiguration()
    },

    onRowClick (rowData: any): void {
      this.isEdit = false
      this.selectedConfigurationIndex = this.configurationList.indexOf(rowData.data)
      this.selectedConfiguration = rowData.data
      this.setForm()
    },

    onCancelClick (): void {
      this.isEdit = false
      this.setForm()
    },

    cancel (action?: KeyAction | null): void {
      if(action) {
        action.event.preventDefault()
      }

      this.onCancelClick()
    },

    onSaveButtonClick (): void {
      const form: any = this.$refs['form']

      if (form.validate()) {
        if (this.selectedConfiguration) {
          this.updateConfiguration()
        } else {
          this.createConfiguration()
        }
      }
    },

    save (action?: KeyAction | null): void {
      if(action) {
        action.event.preventDefault()
      }

      this.onSaveButtonClick()
    },

    createConfiguration (): void {
      console.log('CREATE')
      this.isEdit = false
    },

    updateConfiguration (): void {
      console.log('UPDATE')
      this.isEdit = false
    },

    deleteConfiguration (): void {
      console.log('DELETE')
      this.onDeleteDialogClose()
      this.fetchConfigurationList()
    },

    fetchConfigurationList (): void {
      this.configurationList = this.formData

      this.setForm()
    },

    fetchMetadata (): void {

      this.artList = [
        {id: 1, label: 'Test1'},
        {id: 2, label: 'Test2'},
        {id: 3, label: 'Test3'}
      ]
    },

    onResize (): void {
      if(this.$refs.formSection && this.$vuetify.breakpoint.mdAndUp) {
        const vh = window.innerHeight
        if(vh > 500) {
          const height = (this.$refs.formSection as HTMLElement).clientHeight
          this.tableHeight = `height: calc(${vh}px - 184px - ${height}px)`
        } else {
          this.tableHeight = '300px'
        }
      } else {
        this.tableHeight = '300px'
      }
    },

    setForm (): void {
      if(!this.selectedConfiguration) {
        if(this.configurationList && this.configurationList[0]) {
          this.selectedConfigurationIndex = 0
          this.selectedConfiguration = this.configurationList[0]

          //@ts-ignore
          setTimeout(() => {this.$refs.dataGrid.instance.selectRows([this.configurationList[0].ID])}, 100)
        }
      }

      this.gruppe = this.selectedConfiguration && this.selectedConfiguration.FeldtypeGruppe ? this.selectedConfiguration.FeldtypeGruppe : null
      this.code = this.selectedConfiguration && this.selectedConfiguration.Code ? this.selectedConfiguration.Code : null
      this.bezeichnung = this.selectedConfiguration && this.selectedConfiguration.Bezeichnung ? this.selectedConfiguration.Bezeichnung : null
      this.art = this.selectedConfiguration && this.selectedConfiguration.Art ? this.selectedConfiguration.Art : null
      this.pflichtfeld = this.selectedConfiguration && this.selectedConfiguration.Pflichtfeld ? this.selectedConfiguration.Pflichtfeld : false
      this.produkt = this.selectedConfiguration && this.selectedConfiguration.DefaultProdukt ? this.selectedConfiguration.DefaultProdukt : false
      this.produktadresse = this.selectedConfiguration && this.selectedConfiguration.DefaultProduktAdresse ? this.selectedConfiguration.DefaultProduktAdresse : false
      this.adresse = this.selectedConfiguration && this.selectedConfiguration.DefaultAdresse ? this.selectedConfiguration.DefaultAdresse : false
      this.sachbearbeiter = this.selectedConfiguration && this.selectedConfiguration.DefaultSachbearbeiter ? this.selectedConfiguration.DefaultSachbearbeiter : false
      this.projekt = this.selectedConfiguration && this.selectedConfiguration.DefaultProjekt ? this.selectedConfiguration.DefaultProjekt : false
      this.projektDetail = this.selectedConfiguration && this.selectedConfiguration.DefaultProjektDetail ? this.selectedConfiguration.DefaultProjektDetail : false
      this.stammSLKomponente = this.selectedConfiguration && this.selectedConfiguration.DefaultStuecklistenKomponente ? this.selectedConfiguration.DefaultStuecklistenKomponente : false
      this.projektSLKomponente = this.selectedConfiguration && this.selectedConfiguration.DefaultDetailSLKomponente ? this.selectedConfiguration.DefaultDetailSLKomponente : false
      this.kommission = this.selectedConfiguration && this.selectedConfiguration.DefaultKommission ? this.selectedConfiguration.DefaultKommission : false
      this.seriennummer = this.selectedConfiguration && this.selectedConfiguration.DefaultSeriennummer ? this.selectedConfiguration.DefaultSeriennummer : false
      this.profitCenter = this.selectedConfiguration && this.selectedConfiguration.DefaultProfitcenter ? this.selectedConfiguration.DefaultProfitcenter : false
      this.produktOPSchritte = this.selectedConfiguration && this.selectedConfiguration.DefaultOperationsplanSchritte ? this.selectedConfiguration.DefaultOperationsplanSchritte : false
      this.projektDetailOPSchritte = this.selectedConfiguration && this.selectedConfiguration.DefaultDetailOPSchritte ? this.selectedConfiguration.DefaultDetailOPSchritte : false
      this.mitarbeiter = this.selectedConfiguration && this.selectedConfiguration.DefaultMitarbeiter ? this.selectedConfiguration.DefaultMitarbeiter : false
      this.projektSerien = this.selectedConfiguration && this.selectedConfiguration.DefaultProjektSerien ? this.selectedConfiguration.DefaultProjektSerien : false
    }
  },

  beforeMount () {
    this.keyActions = [
      new Create(KeyActionEnum.create, this.create, this.resolver,  null),
      new Edit(KeyActionEnum.edit, this.update, this.resolver, null),
      new Delete(KeyActionEnum.delete, this.delete, this.resolver, null),
      new Save(KeyActionEnum.save, this.save, this.resolver, null),
      new Cancel(KeyActionEnum.cancel, this.cancel, this.resolver, null),
    ]
  },

  mounted () {
    window.addEventListener('keydown', this.onKeydown)

    this.languagesDialogDescriptionData = this.uiLanguageList.map((item: UiLanguageItem) => {
      return {
        languageId: item.syzId,
        text : ''
      }
    })

    setTimeout(() => { this.onResize() }, 0)
    this.fetchMetadata()
    this.fetchConfigurationList()
  },

  beforeDestroy (): void {
    window.removeEventListener('keydown', this.onKeydown)
  }
})
